import React from 'react'
import { Button } from 'semantic-ui-react'
import { LeftArrowLinkButton } from '../../components/LeftArrowLinkButton'
import styles from './styles.module.less'

const EditOrSubmitTrade = ({
  onModeButtonClick,
  onSubmit,
}: {
  onModeButtonClick: () => void
  onSubmit: () => void
}) => (
  <div className={`edit-or-submit-trade ${styles.editOrSubmitTrade}`}>
    <LeftArrowLinkButton linkText="Edit Details" onClick={onModeButtonClick} />
    <Button className={styles.submitTradeButton} onClick={onSubmit}>
      Submit Trade
    </Button>
  </div>
)

export default EditOrSubmitTrade
